import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { getSettings } from "@/api";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import TrackOrder from "@/pages/TrackOrder";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const AnnouncementBar = () => {
  const [text, setText] = useState("");
  useEffect(() => {
    getSettings()
      .then((s) => {
        if (s.announcement_enabled && s.announcement) setText(s.announcement);
      })
      .catch(() => {});
  }, []);
  if (!text) return null;
  return (
    <div
      data-testid="announcement-bar"
      className="fixed bottom-0 inset-x-0 z-50 bg-maroon-ink text-gold-light text-center text-[10px] sm:text-[11px] tracking-[0.25em] uppercase py-2.5 px-6 border-t border-gold/30"
    >
      {text}
    </div>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.lenisRef?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const LenisRoot = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    window.lenisRef = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <LenisRoot>
        <CartProvider>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col bg-ivory">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order-success/:orderId" element={<OrderSuccess />} />
                <Route path="/track" element={<TrackOrder />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </main>
            <Footer />
            <CartDrawer />
            <AnnouncementBar />
            <Toaster position="top-center" />
          </div>
        </CartProvider>
      </LenisRoot>
    </BrowserRouter>
  );
}

export default App;
